module.exports = __webpack_public_path__ + "img/kroll.79c50c29.png";